import React from "react";
import { HyMailAILarge } from "icons";
import popper from "images/partyPopper.svg"
import fireworks from "images/fireworks.svg"
export default ({ classes, appName, header, content, bottomHeader, features, button }) => {
  const renderIcons = (item, index) => {
    return <Feature item={item} classes={classes} key={index} />;
  };
  return (
    <div className={classes.slideIntro}>
      <div className={classes.partyPopper}>
        <img src={popper} alt="" />
      </div>
      <div className={classes.fireWorks}>
        <img src={fireworks} alt="" />
      </div>
      <div className={classes.introContainerHeader}>
        <div className={classes.logoClass}>
          <HyMailAILarge />
        </div>
        <div className={classes.introTitle}>{appName}</div>
      </div>
      <div className={classes.introContainer}>
        <div className={classes.introHeader}>{header}</div>
        <div className={classes.introContent}>{content}</div>
        {/* <Button className={classes.buttonStyle}>{button}</Button> */}
      </div>
      <div className={classes.bottomContainer}>
        <div className={classes.bottomHeader}>{bottomHeader}</div>
        <div className={classes.features}>{features.map(renderIcons)}</div>
      </div>
    </div>
  );
};

export const Feature = ({ classes, item }) => {
  return (
    <div className={classes.featureContainer}>
      <div className={classes.featureIcon}>{item.icon}</div>
      <div className={classes.feature}>{item.feature}</div>
    </div>
  );
};